import { createRouter, createWebHistory } from 'vue-router';
import LoginForm from '../components/LoginForm.vue';
import OverviewPanel from '../components/OverviewPanel.vue';
import MetricsPanel from '../components/MetricsPanel.vue';
import AdminFulfillment from '../components/AdminFulfillment.vue';
import MyDonations from '../components/MyDonations.vue';
import DonationDetail from '../components/DonationDetail.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: LoginForm },
  { path: '/overview', component: OverviewPanel, meta: { requiresAuth: true } },
  { path: '/metrics', component: MetricsPanel, meta: { requiresAuth: true } },
  { path: '/admin/fulfillment', component: AdminFulfillment, meta: { requiresAuth: true } },
  {
    path: '/admin/fulfillment/:qr',
    name: 'AdminTicketDetail',
    component: () => import('../components/AdminTicketDetail.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  { path: '/my-donations', component: MyDonations, meta: { requiresAuth: true } },
  {
    path: '/donations/:code',
    name: 'DonationDetail',
    component: DonationDetail,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-donations/:qr',
    name: 'MyDonationDetail',
    component: () => import('../components/MyDonationDetail.vue'),
    props: true,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem('token');
  if (to.meta.requiresAuth && !token) {
    alert('Your session has expired. Please log in again.');
    next('/login');
  } else {
    next();
  }
});

export default router;